import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useOktaAuth } from '@okta/okta-react'
import { LoginBackground } from './LoginBackground'
import { configurationStoreSelector, connectionStoreSelector } from 'selectors/storeSelectors'
import { diagnosticsLogger } from 'logger/diagnosticsLogger'
import { useOnMount } from 'view/hooks'

export const Logout = () => {
  const navigate = useNavigate()
  const configuration = useSelector(configurationStoreSelector)
  const authenticationEnabled = !!configuration.authentication?.enabled

  useEffect(() => {
    if (!authenticationEnabled) {
      navigate('/')
    }
  }, [authenticationEnabled, navigate])

  if (!authenticationEnabled) return null

  return <OktaLogout />
}

const OktaLogout = () => {
  const { oktaAuth } = useOktaAuth()
  const navigate = useNavigate()
  const connection = useSelector(connectionStoreSelector)

  useOnMount(() => {
    async function validate() {
      const { lastErrorMessage, lastSocketErrorMessage } = connection

      // if we are already logged out in another window then this will fail (404 in http DELETE to Okta server)
      // so we catch the error and redirect to root
      if (oktaAuth) {
        try {
          if (!lastErrorMessage && !lastSocketErrorMessage) {
            oktaAuth.tokenManager.clear()
            await oktaAuth.signOut()
          } else {
            navigate('/login')
          }
        } catch (err) {
          console.error('Caught error when logging out - redirecting to root', err)
          navigate('/')
        }
      }
    }

    validate()
  })

  diagnosticsLogger.log('User being logged out')
  return <LoginBackground showSpinner={true} />
}
